import { AppProvider } from "./app-provider";
import { FiltroDataModel, AppModel, Tenant } from "./app-model";

export class AppContextActions {
  constructor(private provider: AppProvider) {
    // super();
  }

  setFilterDates(filterModel: FiltroDataModel) {
    this.changeModel((newState) => {
      newState.filtroModel = filterModel;
    });
  }

  setTenants(tenants: Tenant[]) {
    this.changeModel((newState) => {
      newState.tenants = tenants;
    });

  }

  private changeModel = (
    onChange: (model: AppModel) => void
  ): Promise<AppModel> => {
    return new Promise<AppModel>((resolve, _) => {
      let newState = { ...this.provider.state.model };
      onChange(newState as AppModel);
      this.provider.setProviderState(newState, () => {
        resolve(newState as AppModel);
      });
    });
  };
}
